import { render, staticRenderFns } from "./storeInfo.vue?vue&type=template&id=3d8d1f1a&scoped=true&"
import script from "./storeInfo.vue?vue&type=script&lang=js&"
export * from "./storeInfo.vue?vue&type=script&lang=js&"
import style0 from "./storeInfo.vue?vue&type=style&index=0&id=3d8d1f1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8d1f1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/ecommerce_h5_dev_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3d8d1f1a', component.options)
    } else {
      api.reload('3d8d1f1a', component.options)
    }
    module.hot.accept("./storeInfo.vue?vue&type=template&id=3d8d1f1a&scoped=true&", function () {
      api.rerender('3d8d1f1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main/storeInfo.vue"
export default component.exports